import React from 'react';
import { RadioButton, RadioButtonGroup } from '../../../shared/RadioButtonGroup';
import styles from './KPILeanSelect.module.css';

function KPILeanSelect({ value, onChange }) {
  return (
    <RadioButtonGroup value={value} onChange={onChange} className={styles.group}>
      <RadioButton value="y" className={styles.button}>
        Left Y
      </RadioButton>
      <RadioButton value="yRight" className={styles.button}>
        Right Y
      </RadioButton>
    </RadioButtonGroup>
  );
}

export default KPILeanSelect;
